import React from "react"
import {
  STATUS_PENDING,
  STATUS_CONFIRMED,
  STATUS_SEATED,
  STATUS_CANCELLED,
  STATUS_NO_SHOW,
  STATUS_WALK_IN,
  ReservationStatus,
} from "@/constants/reservations"
import Chip from "@mui/material/Chip"
import { ChipOwnProps } from "@mui/material/Chip/Chip"

type ReservationStatusLabelProps = {
  status: ReservationStatus | null
}
const ReservationStatusLabel = ({ status }: ReservationStatusLabelProps) => {
  const CHIP_STATUSES = {
    [STATUS_PENDING]: "primary",
    [STATUS_CONFIRMED]: "success",
    [STATUS_SEATED]: "info",
    [STATUS_CANCELLED]: "error",
    [STATUS_NO_SHOW]: "warning",
    [STATUS_WALK_IN]: "success",
  }
  const color = (CHIP_STATUSES[status] as ChipOwnProps["color"]) || "default"

  return (
    <Chip label={status} color={color} size="small" data-testid={`reservation-status-label-${status || "unknown"}`} />
  )
}
export default ReservationStatusLabel
